class ServiceConfig {
  //static API_URL  = 'http://localhost:8000';
  static API_URL  = 'https://www.b-toern.de';
}

export default ServiceConfig

